import * as types from '../../../../constants/ActionNameConstants';

const INITIAL_STATE = {
  loading: false,
  user: [],
  error: null,
};

const LoginReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.VALIDATE_LOGIN_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.VALIDATE_LOGIN_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case types.VALIDATE_LOGIN_USER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default LoginReducer;
